"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeRateToJSON = exports.FeeRateFromJSONTyped = exports.FeeRateFromJSON = void 0;
function FeeRateFromJSON(json) {
    return FeeRateFromJSONTyped(json, false);
}
exports.FeeRateFromJSON = FeeRateFromJSON;
function FeeRateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fee_rate': json['fee_rate'],
    };
}
exports.FeeRateFromJSONTyped = FeeRateFromJSONTyped;
function FeeRateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fee_rate': value.fee_rate,
    };
}
exports.FeeRateToJSON = FeeRateToJSON;
//# sourceMappingURL=FeeRate.js.map